export const categories = [
  { slug: 'all', name: '全部故事', icon: 'ri-book-open-line' },
  { slug: 'urban-romance', name: '都市情感', icon: 'ri-heart-line' },
  { slug: 'suspense', name: '悬疑剧情', icon: 'ri-search-eye-line' },
  { slug: 'character-legend', name: '人物传奇', icon: 'ri-user-star-line' },
  { slug: 'night-tales', name: '深夜物语', icon: 'ri-moon-line' },
  { slug: 'town-secrets', name: '小镇秘闻', icon: 'ri-lock-line' },
];

export const articles = [
  {
    slug: 'night-of-the-bar-owner',
    title: '酒吧老板的不眠夜',
    category: 'urban-romance',
    excerpt: '小镇的夜色总是格外迷人，霓虹灯在潮湿的空气中晕开一圈圈光影。林薇站在酒吧二楼的窗前，看着街上稀疏的行人，手中的香烟已经燃到了尽头。她回想起三年前刚来到这个小镇时的情景...',
    coverImage: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20bar%20interior%20with%20neon%20lights%20reflecting%20on%20rain%20soaked%20window%2C%20moody%20noir%20atmosphere%2C%20a%20woman%20silhouette%20by%20the%20window%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20lighting%2C%20artistic%20film%20grain%20texture&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '林薇',
    date: '2026-08-10',
    readTime: '12分钟',
    views: 3842,
    tags: ['酒吧', '情感', '都市'],
    featured: true,
    content: [
      { type: 'p', text: '小镇的夜色总是格外迷人，霓虹灯在潮湿的空气中晕开一圈圈光影。林薇站在酒吧二楼的窗前，看着街上稀疏的行人，手中的香烟已经燃到了尽头。' },
      { type: 'h2', text: '初到小镇' },
      { type: 'p', text: '她回想起三年前刚来到这个小镇时的情景。那时候的她，带着满身的伤痕和一箱简单的行李，在一个雨夜里走进了这家名叫"夜色"的酒吧。老板是个沉默寡言的中年男人，看了她一眼，只说了一句："会调酒吗？"' },
      { type: 'p', text: '"会一点。"林薇回答。就是从那个夜晚开始，她的命运与这家酒吧紧紧绑在了一起。小镇不大，但故事却不少。每个深夜来喝酒的人，都带着自己的秘密和心事。' },
      { type: 'h2', text: '深夜来客' },
      { type: 'p', text: '那天晚上十一点，酒吧快要打烊的时候，一个穿着黑色风衣的男人推门进来。他浑身湿透，头发贴在额头上，在吧台前坐下，要了一杯最烈的威士忌。林薇注意到他的手上有一道新鲜的伤痕，血液已经被雨水冲淡。' },
      { type: 'p', text: '"外面雨很大。"林薇一边倒酒一边说。男人没有回答，只是盯着杯中琥珀色的液体，像是在透过那杯酒看另一个世界。过了很久，他才低声说了一句："我叫沈墨。"' },
      { type: 'h2', text: '秘密浮现' },
      { type: 'p', text: '接下来的几个星期，沈墨每晚都会在十一点准时出现在酒吧。他从不与人交谈，总是坐在角落的同一个位置，点同样的威士忌。林薇开始对他产生了好奇——这个神秘的男人身上到底藏着什么样的故事？' },
      { type: 'p', text: '直到有一天，小镇上发生了一起离奇的失踪案。警察开始挨家挨户地询问线索。当警察走进酒吧，看到角落里的沈墨时，他们的表情明显变得紧张起来。林薇这才意识到，这个沉默的顾客可能比她想象的要复杂得多。' },
      { type: 'h2', text: '真相之夜' },
      { type: 'p', text: '那个夜晚，沈墨比平时来得更晚。他坐在吧台前，第一次主动开口跟林薇说话："你知道这个小镇最大的秘密是什么吗？"林薇摇了摇头。' },
      { type: 'p', text: '"每个人都在演戏，"沈墨轻声说，"包括你，林老板。"他叫她"林老板"——那是只有酒吧老客人才会用的称呼。但沈墨明明是最近才来到小镇的。除非，他早就认识她。' },
      { type: 'p', text: '林薇的手微微颤抖了一下，但她很快恢复了平静。"你到底是什么人？"' },
      { type: 'p', text: '沈墨从风衣内袋里掏出一张泛黄的照片，放在吧台上推了过来。照片上是一个年轻女孩，笑容灿烂地站在一家酒吧门口——那正是三年前的林薇。而酒吧的名字，不叫"夜色"，叫"旧梦"。' },
      { type: 'h2', text: '未完待续' },
      { type: 'p', text: '窗外的雨越下越大，敲打着玻璃发出密集的声响。林薇盯着那张照片，记忆如同潮水般涌来。三年前的那个夜晚，她逃离的不仅仅是一座城市，还有一个她以为永远不会再被提及的过去。' },
      { type: 'p', text: '"所以，你找到我了。"林薇的声音很轻，像是自言自语。' },
      { type: 'p', text: '沈墨端起酒杯，琥珀色的液体在昏黄的灯光下微微晃动。"不是找到，是我一直都知道你在哪里。"' },
    ],
  },
  {
    slug: 'secrets-behind-the-flower-shop',
    title: '花店背后的秘密',
    category: 'suspense',
    excerpt: '小镇东街的转角处有一家不起眼的花店，店主是个叫苏晴的年轻女人。她总是穿着一袭素色的长裙，安静地修剪着花枝。但没有人知道，这家花店的二楼，藏着一个惊人的秘密...',
    coverImage: 'https://readdy.ai/api/search-image?query=Charming%20flower%20shop%20at%20street%20corner%20with%20vintage%20wooden%20storefront%2C%20soft%20morning%20light%20casting%20long%20shadows%2C%20bouquets%20of%20roses%20and%20lilies%20in%20display%20window%2C%20mysterious%20atmosphere%2C%20warm%20beige%20and%20soft%20pink%20tones&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '苏晴',
    date: '2026-08-08',
    readTime: '15分钟',
    views: 5621,
    tags: ['花店', '悬疑', '小镇'],
    featured: true,
    content: [
      { type: 'p', text: '小镇东街的转角处有一家不起眼的花店，店主是个叫苏晴的年轻女人。她总是穿着一袭素色的长裙，安静地修剪着花枝。' },
      { type: 'h2', text: '不寻常的订单' },
      { type: 'p', text: '那天下午，一个戴着墨镜的男人走进花店，要了一束白玫瑰。他没有说送给谁，只是在付钱时递过来一张纸条。苏晴打开纸条，上面只写了一个地址和时间。' },
      { type: 'p', text: '这种事情已经不是第一次发生了。自从她接手这家花店以来，每个月都会有这样的特殊订单。起初她以为只是普通的送花服务，直到她发现这些订单的收货地址都是小镇上一些非常特别的地方。' },
      { type: 'h2', text: '二楼密室' },
      { type: 'p', text: '花店的二楼是一个从不对外开放的空间。苏晴对外说那是她的住所，但实际上，那里存放着一个小镇所有人的秘密。每个特殊订单的背后，都藏着一个故事——有些是爱情，有些是背叛，还有一些则是无法言说的阴谋。' },
      { type: 'p', text: '苏晴并非普通的卖花人。她曾是城市里最顶尖的私家侦探，因为一桩悬案的牵连而隐姓埋名来到了这个小镇。花店只是她的伪装，那些特殊的订单，是她继续从事调查工作的一种方式。' },
      { type: 'h2', text: '新的委托' },
      { type: 'p', text: '这次的纸条上写的是一个废弃工厂的地址。苏晴按照约定的时间到达，在昏黄的灯光下见到了委托人——一个满脸沧桑的中年女人。她想找到失踪三年的丈夫，而所有的线索都指向了这个小镇。' },
      { type: 'p', text: '苏晴接下了这个案子。但她没有想到的是，这个看似普通的失踪案，会将她引向一个关于小镇权力核心的漩涡之中。而那个核心人物，正是小镇上最受人尊敬的商会会长。' },
      { type: 'h2', text: '危险的真相' },
      { type: 'p', text: '随着调查的深入，苏晴发现这个小镇比她想象的要复杂得多。每一个看似平静的家庭背后，都有着不为人知的暗流。而她所追查的这桩失踪案，仅仅是冰山一角。那些秘密像花店里的藤蔓一样，盘根错节，相互纠缠。' },
      { type: 'p', text: '当她终于接近真相的时候，一封匿名信出现在花店门口。信上只有一句话："到此为止，否则后果自负。"苏晴知道，她已经触碰到了某些人最敏感的神经。' },
    ],
  },
  {
    slug: 'teacher-at-dusk',
    title: '黄昏时分的美术老师',
    category: 'urban-romance',
    excerpt: '小镇中学的美术老师陈默是个沉默寡言的人。每天黄昏时分，他都会带着画板坐在河边，画着同一片风景。直到有一天，一个陌生的女人出现在他的画布前...',
    coverImage: 'https://readdy.ai/api/search-image?query=Golden%20hour%20sunset%20over%20a%20quiet%20riverbank%2C%20an%20artist%20with%20easel%20painting%20the%20landscape%2C%20warm%20orange%20and%20soft%20pink%20sky%2C%20willow%20trees%20framing%20the%20scene%2C%20romantic%20atmospheric%20lighting%2C%20watercolor%20texture%20style&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '陈默',
    date: '2026-08-06',
    readTime: '10分钟',
    views: 2198,
    tags: ['美术', '黄昏', '爱情'],
    featured: false,
    content: [
      { type: 'p', text: '黄昏是小巷最美的时刻。金色的阳光斜斜地洒在青石板路上，将每个人的影子拉得很长很长。美术老师陈默每天都会在这个时候来到河边，支起画架。' },
      { type: 'h2', text: '画中的风景' },
      { type: 'p', text: '他画的是同一片风景——河对岸的老房子、垂柳、还有那座有了年头的石桥。日复一日，年复一年。学生们都觉得这位老师有些古怪，但他们不知道的是，陈默在等的不是风景，而是一个人。' },
      { type: 'p', text: '五年前，也是这样一个黄昏，他在河边第一次遇见了她。她穿着一件米色的连衣裙，站在石桥上，夕阳在她的头发上镀了一层金色的光晕。陈默记得自己当时屏住了呼吸，生怕惊扰了这幅画面。' },
      { type: 'h2', text: '重逢' },
      { type: 'p', text: '那个黄昏，当陈默如往常一样来到河边时，他愣住了。石桥上站着一个女人，穿着米色的连衣裙，和五年前一模一样的场景。他揉了揉眼睛，以为自己出现了幻觉。' },
      { type: 'p', text: '女人转过身来，正是她。"你还在这里画画？"她笑着问，仿佛这五年从未存在过。陈默张了张嘴，却发现千言万语都堵在了喉咙里。' },
      { type: 'h2', text: '未完的画' },
      { type: 'p', text: '那天傍晚，他们在河边坐了很久。他知道了她这五年的经历，她也看到了他画册里那些只画了一半的风景——因为每一幅画里，都缺了一个人的身影。现在，那个人回来了，那些画终于可以完成了。' },
    ],
  },
  {
    slug: 'midnight-taxi-driver',
    title: '午夜出租车司机',
    category: 'night-tales',
    excerpt: '老张开出租车已经有二十年了。他开的是夜班，从晚上八点到第二天早上六点。在这个时间段里，他见过形形色色的人——醉酒的、失恋的、离家出走的...但那天晚上的乘客，让他至今想起来都觉得后背发凉。',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20street%20at%20midnight%20with%20a%20yellow%20taxi%20under%20a%20single%20streetlamp%2C%20foggy%20and%20moody%20atmosphere%2C%20wet%20pavement%20reflecting%20dim%20light%2C%20dark%20green%20and%20deep%20amber%20tones%2C%20cinematic%20noir%20style&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '老张',
    date: '2026-08-05',
    readTime: '8分钟',
    views: 4531,
    tags: ['出租车', '深夜', '惊悚'],
    featured: true,
    content: [
      { type: 'p', text: '老张开出租车已经有二十年了。他开的是夜班，从晚上八点到第二天早上六点。在这个时间段里，他见过形形色色的人。' },
      { type: 'h2', text: '深夜的乘客' },
      { type: 'p', text: '那天凌晨两点，老张在火车站等客。一个穿着旗袍的女人敲了敲车窗，说要去镇子最西边的墓地。老张心里咯噔了一下——这个时间，去那种地方？' },
      { type: 'p', text: '女人看起来很平静，甚至还带着一丝微笑。她说今天是母亲的忌日，白天太忙了没有去，只能趁夜里去祭拜。老张虽然觉得诡异，但毕竟做了这么多年夜班司机，什么怪事没见过，便发动了车子。' },
      { type: 'h2', text: '消失的乘客' },
      { type: 'p', text: '到了墓地门口，女人付了钱下车。老张习惯性地看了一眼后视镜——后座空空如也。他猛地回头，车门关得好好的，但女人已经不见了踪影。更让他心里发毛的是，刚才女人付的车费，是几张已经不再流通的旧版纸币。' },
      { type: 'p', text: '老张后来跟同行说起这件事，才知道原来二十年前，确实有一个穿旗袍的女人在那个墓地附近遇害，案子至今未破。从那以后，老张再也不接去墓地的单子了。' },
    ],
  },
  {
    slug: 'the-mayors-daughter',
    title: '镇长的女儿',
    category: 'town-secrets',
    excerpt: '镇长的女儿赵小曼是小镇上最引人注目的女孩——漂亮、优秀、家境优渥。但她有一个不为人知的秘密：每天晚上，她都会偷偷溜出家门，去镇子边缘的一家小面馆里打工...',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20young%20woman%20walking%20through%20a%20narrow%20alley%20at%20night%2C%20dim%20lantern%20light%2C%20traditional%20Chinese%20small%20town%20architecture%2C%20mysterious%20and%20secretive%20mood%2C%20deep%20navy%20and%20warm%20lantern%20glow&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '赵小曼',
    date: '2026-08-03',
    readTime: '11分钟',
    views: 6789,
    tags: ['镇长', '秘密', '小镇'],
    featured: false,
    content: [
      { type: 'p', text: '在所有人的眼里，赵小曼的人生是完美的。她是镇长的独生女，成绩优异，长相出众，是小镇上所有父母口中的"别人家的孩子"。' },
      { type: 'h2', text: '双重生活' },
      { type: 'p', text: '但没有人知道，每到晚上十点，当镇长家的灯光熄灭之后，赵小曼会换上一身最普通的衣服，从二楼的窗户翻出去，骑着一辆破旧的自行车，穿过大半个镇子，来到一家名叫"老王面馆"的小店里。' },
      { type: 'p', text: '她在这里当洗碗工。不是因为缺钱——镇长家当然不缺钱。而是因为这家面馆的老板，是她亲生父亲。一个连镇长都不知道的秘密。' },
      { type: 'h2', text: '身世之谜' },
      { type: 'p', text: '赵小曼十三岁那年，在母亲的遗物中发现了一封信。信里说，她的生父不是镇长，而是一个从小镇来城里打工的面馆师傅。母亲当年因为家庭的反对，无奈嫁给了当时还是小科员的镇长。' },
      { type: 'p', text: '从那以后，赵小曼花了整整五年的时间找到了生父。那个沉默寡言的面馆老板，见到她的第一眼就哭了。他们没有公开相认——因为那会让太多人的生活崩塌。所以，每晚的洗碗时光，成了他们之间最珍贵的秘密。' },
      { type: 'h2', text: '风暴来临' },
      { type: 'p', text: '然而秘密终究是藏不住的。镇上一个好事的邻居拍到了赵小曼深夜出入面馆的照片，谣言开始在镇上蔓延。有人说她交了不三不四的男朋友，有人说她参与了一些见不得人的勾当。镇长知道后勃然大怒，决定要彻查此事。' },
      { type: 'p', text: '面对即将到来的风暴，赵小曼必须做出选择——是继续隐藏真相，还是将一切公布于众，哪怕这意味着两个家庭都会支离破碎。' },
    ],
  },
  {
    slug: 'waitress-in-the-rain',
    title: '雨中的女服务员',
    category: 'urban-romance',
    excerpt: '小镇咖啡馆的女服务员周小棠是个爱笑的姑娘。无论晴天还是雨天，她总是带着温暖的微笑为客人端上咖啡。直到那天，咖啡馆来了一位特殊的客人...',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20coffee%20shop%20interior%20with%20rain%20on%20window%2C%20warm%20steaming%20coffee%20cup%20on%20wooden%20table%2C%20soft%20golden%20light%20from%20vintage%20pendant%20lamp%2C%20intimate%20atmosphere%2C%20cream%20and%20copper%20tones&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '周小棠',
    date: '2026-08-01',
    readTime: '9分钟',
    views: 3120,
    tags: ['咖啡馆', '雨天', '邂逅'],
    featured: false,
    content: [
      { type: 'p', text: '周小棠已经在这家咖啡馆工作了两年。她喜欢这份工作，因为可以观察到形形色色的客人——匆忙的白领、悠闲的老人、甜蜜的情侣，还有那些独自坐在角落里写着什么的人。' },
      { type: 'h2', text: '特殊的客人' },
      { type: 'p', text: '那是一个下着大雨的下午。咖啡馆里人不多，周小棠正在擦拭咖啡机。门铃响了，一个浑身湿透的男人走了进来。他看起来很疲惫，眼眶下有明显的黑眼圈。' },
      { type: 'p', text: '"来一杯最苦的美式。"他说。周小棠注意到，他在说到"苦"字的时候，嘴角微微抽搐了一下。她默默地在咖啡里多加了一泵糖浆——有时候，生活已经够苦了，不需要更苦。' },
      { type: 'h2', text: '雨天的约定' },
      { type: 'p', text: '从那以后，每个雨天，那个男人都会来。他总是在下午三点左右出现，点同样的一杯咖啡，坐在靠窗的同一个位置。周小棠也习惯了在每个雨天给他多加一泵糖浆。' },
      { type: 'p', text: '终于有一天，男人在杯垫下留了一张纸条："谢谢你偷偷给我加糖。我叫陆远，可以请你喝杯咖啡吗？——当然，不是在这里，是在任何不下雨的地方。"' },
    ],
  },
  {
    slug: 'pharmacist-late-night',
    title: '深夜药店的药剂师',
    category: 'night-tales',
    excerpt: '镇上唯一一家二十四小时药店的药剂师是个叫李明的年轻人。他的工作清闲，因为半夜来买药的人实在不多。但每一个深夜来买药的人，都带着一个不为人知的故事...',
    coverImage: 'https://readdy.ai/api/search-image?query=Small%20pharmacy%20at%20night%20with%20warm%20light%20glowing%20through%20glass%20door%2C%20shelves%20of%20medicine%20bottles%2C%20quiet%20empty%20street%20outside%2C%20lonely%20atmosphere%2C%20soft%20green%20and%20cream%20tones&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '李明',
    date: '2026-07-30',
    readTime: '7分钟',
    views: 1876,
    tags: ['药店', '深夜', '众生相'],
    featured: false,
    content: [
      { type: 'p', text: '李明是个药剂师。他的工作很清闲——毕竟半夜来买药的人实在不多。但每一个深夜推开药店门的人，都带着一个不为人知的故事。' },
      { type: 'h2', text: '失眠的人们' },
      { type: 'p', text: '最常见的顾客是失眠的人。他们穿着睡衣，神色疲惫，要一小瓶安眠药。李明会按照规定只给三天的剂量，然后再附赠一句："如果三天后还是睡不着，就来找我聊聊天吧，聊天比药管用。"' },
      { type: 'p', text: '有一个中年男人连续来了一个月。起初他什么都不说，只是默默付钱拿药。后来有一天，他突然开口了："我老婆走了，房子空荡荡的，睡不着。"那天晚上，李明和他聊到了天亮。' },
      { type: 'h2', text: '深夜的救赎' },
      { type: 'p', text: '也有让人难忘的顾客。比如那个凌晨三点抱着发烧孩子狂奔而来的年轻母亲。李明细心地配好了退烧药，还帮忙叫了镇上的出租车。又比如那个手臂上全是伤痕的老奶奶——李明发现了她受虐待的迹象，悄悄报了警。' },
      { type: 'p', text: '李明觉得，一家深夜药店的价值，不在于卖出了多少药，而在于为那些在深夜里无处可去的人，提供了一个可以暂时停靠的地方。' },
    ],
  },
  {
    slug: 'antique-shop-owner',
    title: '古董店的老板娘',
    category: 'character-legend',
    excerpt: '古董店的老板娘姓许，大家都叫她许姨。她的店铺里摆满了各种各样的老物件——瓷器、字画、老家具。每一件东西背后，都藏着一段跨越时空的故事...',
    coverImage: 'https://readdy.ai/api/search-image?query=Vintage%20antique%20shop%20with%20dusty%20sunlight%20beams%2C%20old%20porcelain%20vases%20and%20wooden%20furniture%2C%20an%20elderly%20woman%20at%20the%20counter%2C%20nostalgic%20and%20warm%20atmosphere%2C%20sepia%20and%20amber%20tones&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '许姨',
    date: '2026-07-28',
    readTime: '14分钟',
    views: 2904,
    tags: ['古董', '传奇', '故事'],
    featured: true,
    content: [
      { type: 'p', text: '许姨的古董店在小镇最老的那条街上。店面不大，但里面的东西却足以讲述小镇一百年的历史。每一件老器物，她都如数家珍——哪件是从哪个老宅子里收来的，哪件背后藏着怎样的故事。' },
      { type: 'h2', text: '最珍贵的藏品' },
      { type: 'p', text: '店里最珍贵的不是那些标价最高的瓷器和字画，而是一个普通的桃木梳子。那是许姨的母亲留给她的，也是整个古董店里唯一不卖的东西。' },
      { type: 'p', text: '"这把梳子啊，"许姨常说，"是我妈十六岁时候的嫁妆。那个年代的姑娘，一把桃木梳子就是一个女人全部的心事。梳了六十年的头发，每一根齿缝里都藏着岁月的痕迹。"' },
      { type: 'h2', text: '故人归来' },
      { type: 'p', text: '那天，一个白发苍苍的老人走进了古董店。他仔细地看着每一样东西，最后在一只青花瓷碗前停下了脚步。他的手微微颤抖着，从口袋里掏出放大镜，细细地看碗底的落款。' },
      { type: 'p', text: '"这只碗，"老人抬起头，眼眶红红的，"是当年我家被抄走的东西。我找了它六十年了。"许姨什么也没说，把碗包好，递给了老人。"物归原主，不收钱。"' },
      { type: 'p', text: '老人抱着碗哭了很久。许姨说，这就是她开古董店的意义——让那些被时光冲散的人和物，终有一天能够重聚。' },
    ],
  },
  {
    slug: 'the-runaway-bride',
    title: '逃跑的新娘',
    category: 'urban-romance',
    excerpt: '婚礼前夜，新娘沈悦从酒店的窗户逃走了。她穿着婚纱，光着脚，在漆黑的夜色中狂奔。所有的人都认为她疯了——新郎是小镇首富的儿子，这桩婚事是多少女孩梦寐以求的。但沈悦知道，她逃的不是婚姻，而是一个精心布置的陷阱...',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20in%20white%20wedding%20dress%20running%20through%20a%20dark%20alley%20at%20night%2C%20dress%20trailing%20behind%2C%20dramatic%20lighting%20from%20streetlamp%2C%20motion%20blur%20effect%2C%20moody%20and%20liberating%20atmosphere&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '沈悦',
    date: '2026-07-25',
    readTime: '13分钟',
    views: 8743,
    tags: ['婚礼', '逃跑', '勇气'],
    featured: true,
    content: [
      { type: 'p', text: '婚礼前夜，沈悦穿着那件价值不菲的定制婚纱，站在酒店二十三楼的窗前。楼下是小镇最繁华的街道，霓虹闪烁，人来人往。她知道，明天会有三百个宾客来见证她的婚礼。但此刻，她只想逃跑。' },
      { type: 'h2', text: '完美的陷阱' },
      { type: 'p', text: '在所有人眼中，这是一桩完美的婚姻。新郎赵子航——小镇首富赵家的独子，英俊多金，海外留学归来。但没有人知道，在那些华丽的外表之下，藏着一个控制欲极强的暴君。' },
      { type: 'p', text: '沈悦是婚礼前两周才发现真相的。她在赵子航的电脑里看到了他跟踪她的记录——每一天、每一个小时、她去过的每一个地方、见过的每一个人。她不是他的新娘，而是他精心收藏的一件物品。' },
      { type: 'h2', text: '逃跑之夜' },
      { type: 'p', text: '她没有带任何行李，脱掉了高跟鞋，从消防通道悄悄溜出了酒店。婚纱的裙摆太长，她撕掉了下半截，露出了里面的衬裙。光着脚踩在冰凉的柏油路上，她却感到前所未有的自由。' },
      { type: 'p', text: '她在深夜的街头拦下一辆过路的大货车。司机是个满脸胡茬的大叔，看到她穿着婚纱的模样吓了一跳。"姑娘，你这是......""逃婚。"沈悦说，然后笑了——那是很久以来她第一次真心地笑。' },
      { type: 'h2', text: '新的开始' },
      { type: 'p', text: '大货车载着她离开了小镇。她不知道要去哪里，但她知道，她正在去往一个可以自由呼吸的地方。手机不断地震动——是赵家和她的父母在疯狂地找她。她把手机扔出了窗外，看着它在地上摔成了碎片。' },
      { type: 'p', text: '天快亮的时候，货车在一个陌生的城市停了下来。沈悦下了车，站在晨光中，深吸了一口气。她身上只有那件撕破的婚纱和口袋里的几百块钱。但她觉得，这是她人生中最富有的时刻。' },
    ],
  },
  {
    slug: 'the-watchmans-diary',
    title: '守夜人的日记',
    category: 'town-secrets',
    excerpt: '镇上殡仪馆的老赵头是个沉默的人。他做了三十年的守夜人，见过最多的生离死别。每个逝去的人背后，都有一段没人知道的往事。老赵头有一个黑色的笔记本，记录着那些不为人知的故事...',
    coverImage: 'https://readdy.ai/api/search-image?query=Old%20man%20sitting%20in%20a%20dimly%20lit%20room%20writing%20in%20a%20worn%20notebook%2C%20single%20desk%20lamp%20casting%20warm%20light%2C%20quiet%20contemplative%20atmosphere%2C%20deep%20brown%20and%20gold%20tones%2C%20vintage%20noir%20style&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '老赵',
    date: '2026-07-22',
    readTime: '16分钟',
    views: 3905,
    tags: ['殡仪馆', '日记', '生死'],
    featured: false,
    content: [
      { type: 'p', text: '殡仪馆的守夜人老赵头今年六十八岁了。三十年来，他守着数以千计的逝者度过了最后一个夜晚。每一次守夜，他都会写一篇日记。' },
      { type: 'h2', text: '黑色的笔记本' },
      { type: 'p', text: '那本笔记本已经翻得起了毛边，里面记录了三十年来每一个让他印象深刻的逝者。有寿终正寝的百岁老人，有英年早逝的年轻人，也有无人认领的流浪者。' },
      { type: 'p', text: '老赵头说："活人看热闹，死人看人心。一个人身前再怎么风光，到了这殡仪馆里，才能真正看出他这辈子值不值。"他把那些无人送别的逝者记得格外仔细，因为觉得他们更需要被记住。' },
      { type: 'h2', text: '最后的秘密' },
      { type: 'p', text: '去年冬天，镇上最有钱的赵老爷子去世了。出殡那天，豪华的车队排了半条街。但老赵头在他的日记里只写了一行字："来了一百二十三个人，没有一个真心哭的。"' },
      { type: 'p', text: '相反，当一个孤寡老人去世时，只有一个衣衫褴褛的流浪汉来送别。那流浪汉在灵前跪了很久很久，最后从怀里掏出一张泛黄的合影——原来他们是失散多年的兄弟。老赵头在这天的日记里写满了整整三页。' },
      { type: 'p', text: '"死亡不会说谎，"老赵头常说，"它能告诉你谁真正爱过、谁真正被爱过。而我，就是那个替他们记住这些的人。"' },
    ],
  },
];

export const aboutInfo = {
  brandName: '淫乱小镇',
  tagline: '在故事中，看见人性的真实',
  introduction: '淫乱小镇是一个原创都市情感故事平台，致力于用文学的方式探索人性的复杂与情感的温度。我们相信，每一个看似平凡的小镇背后，都藏着无数动人的故事。',
  story: '淫乱小镇诞生于一个偶然的灵感。我们的创始人在一次旅行中路过一个不知名的小镇，在街角的咖啡馆里听到了一段陌生人之间的对话。那段对话里包含了爱情、背叛、救赎和希望——所有这些元素交织在一起，成为了一段令人难忘的故事。从那以后，我们开始收集和创作发生在小镇里的故事，并希望将这些故事分享给所有愿意聆听的人。',
  values: [
    { title: '真实的力量', description: '我们相信，最动人的故事源于真实的情感和人性的深度。每一个故事都力求展现人物内心的复杂与真实。' },
    { title: '文学的品质', description: '在通俗与文学之间寻找平衡，让每一个故事都既好看又有深度。我们坚持高品质的文字创作标准。' },
    { title: '包容的视角', description: '不评判、不说教，只是呈现。我们尊重每一个角色的选择和每一条人生道路的多样性。' },
  ],
  team: [
    { name: '林薇', role: '创始人 & 主编', description: '前媒体人，热爱故事与文字。' },
    { name: '苏晴', role: '内容总监', description: '十年编辑经验，对好故事有着敏锐的嗅觉。' },
    { name: '陈默', role: '视觉设计', description: '用画面为故事增添温度。' },
  ],
  contact: {
    email: 'contact@hzhgjs.cn',
    address: '中国上海市静安区南京西路1788号',
    wechat: 'yinluanxiaozhen',
  },
};

export const faqItems = [
  {
    question: '淫乱小镇的故事都是真实的吗？',
    answer: '我们的故事中，一部分取材于真实事件改编，另一部分为原创虚构作品。无论真实还是虚构，我们都力求在故事中呈现真实的情感和人性深度。',
  },
  {
    question: '如何向我们投稿？',
    answer: '我们非常欢迎优秀的故事创作者。您可以将您的作品发送至我们的官方邮箱，我们的编辑团队会在七个工作日内回复。请在邮件主题中注明"投稿"字样。',
  },
  {
    question: '故事更新的频率是怎样的？',
    answer: '我们保持每周更新两到三篇新故事。关注我们的微信公众号可以第一时间获取更新通知，不错过每一个精彩故事。',
  },
  {
    question: '可以转载淫乱小镇上的故事吗？',
    answer: '本站所有内容均为原创，受版权保护。如需转载，请先通过邮箱联系我们获取授权。未经授权的转载行为将被追究法律责任。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过邮箱 contact@hzhgjs.cn 与我们取得联系，或关注微信公众号"淫乱小镇"留言。我们会在工作日48小时内回复。',
  },
];